var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingChargeback
    ? _c("JadeSpinner")
    : _c("div", { staticClass: "mb-6" }, [
        _c(
          "div",
          { staticClass: "mb-6" },
          [
            _vm.shouldDisplayAlert
              ? _c(
                  "JadeAlert",
                  { attrs: { variant: "warning", showIcon: "" } },
                  [
                    _c(
                      "JadeText",
                      { attrs: { variant: "warning", color: "current-color" } },
                      [
                        _vm._v(" " + _vm._s(_vm.$t("alert-title-1")) + " "),
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.remainingDays) +
                              " " +
                              _vm._s(_vm.$t("alert-title-2"))
                          ),
                        ]),
                        _vm._v(" " + _vm._s(_vm.$t("alert-title-3")) + " "),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "w-full flex justify-center" },
          [
            _c(
              "jade-page-container",
              {
                attrs: { size: "wide" },
                scopedSlots: _vm._u([
                  {
                    key: "aside",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "w-280 shrink-0" },
                          [
                            _vm.shouldDisplayDisputeButton
                              ? _c(
                                  "div",
                                  { staticClass: "mb-4" },
                                  [
                                    _c(
                                      "JadeButton",
                                      {
                                        staticClass: "w-full",
                                        attrs: { variant: "primary-solid" },
                                        on: {
                                          click: _vm.redirectToRepresentment,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("create-dispute")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("ChargebackDetailsTimeline", {
                              attrs: {
                                createdAt: _vm.chargebackData.createdAt,
                                statusCode: _vm.chargebackData.status,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("ChargebackDetailsData", {
                  attrs: {
                    amount: _vm.chargebackData.amount,
                    chargebackId: _vm.chargebackId,
                    cardFirstDigits: _vm.chargebackData.cardFirstDigits,
                    cardBrand: _vm.chargebackData.cardBrand,
                    cardHolderName: _vm.chargebackData.cardHolderName,
                    cardNumber: _vm.chargebackData.cardNumber,
                    createdAt: _vm.chargebackData.createdAt,
                    customerDocument: _vm.chargebackData.customerDocument,
                    email: _vm.chargebackData.email,
                    reasonDescription: _vm.chargebackData.reasonDescription,
                    statusCode: _vm.chargebackData.status,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }